<script>
  import Link from "./Link.svelte";
  import LinkForm from './form/Link.svelte';
  // import SubjectForm from './form/Subject.svelte';
  
  import { onMount, afterUpdate, createEventDispatcher } from "svelte";
  import { router } from 'tinro';
  import request from 'superagent';
  
  
  const defaultLink = { id: null, language: "cz", title: "", uri: "" }
  const defaultSubject = { links: [] };
  const dispatch = createEventDispatcher();
  
  export let id = null;
  export let subject = Object.assign({}, defaultSubject);
  export let subject_form_id = null;
  
  $: subject = Object.assign({}, defaultSubject, subject || {}), !('exists' in subject) && getSubject();
  
  let unsavedLinksCount = 0;
  
  function getSubject() {
    if (subject['exists'])
      return;
    subject.id = id;
    fetch(`/ix/x/${window.atob(subject.id)}.json`)
      .then(r => r.json())
      .then(data => {
        subject = Object.assign(subject, defaultSubject, data);
        subject.exists = !!subject.id;
        window.scrollTo(0, 0);
        dispatch('subject', Object.assign({}, defaultSubject, subject));
      })
      .catch(resp => {
        console.log("error when getting subject")
      });
  }
  
  
  function showLinks() {
    visible_content = LINKS_CONTENT;
    if (!('links' in subject))
      subject['links'] = [];
    if (user && !subject.links.length)
      addLink();
  }
  
  function takeLink(link) {
    subject.links[0] = link.detail;
    unsavedLinksCount--;
  }
  
  function addLink() {
    subject.links = [Object.assign({}, defaultLink), ...subject.links];
    unsavedLinksCount++;
    visible_content = LINKS_CONTENT;
  }
  
  function removeLink(index) {
    if (!subject.links[index].id) unsavedLinksCount--;
    let tmp = subject.links
    tmp.splice(index, 1)
    subject.links = tmp
  }
  
  function init() {
    if (subject == null)
      getSubject();
  }
  
  onMount(init)
</script>
<article class='d-flex flex-column rounding-1 px-1' style='min-height: 70%'>
<section class='d-flex flex-row justify-content-between meta text-muted w-100 badge badge-light badge-lg'>
<span>
{#if subject.content}{subject.content.schema}{/if}
</span>
<span>
Zdroje:
<a class='text-muted' href='https://cs.wikipedia.org' title=''>
<i class='fab fa-wikipedia-w'></i>
</a>
</span>
</section>
<div class='border-0 bg-white shadow-sm'>
<div class='d-flex justify-content-between flex-column'>
<h2 class='m-1'>
{#if subject.name}{subject.name}{/if}
</h2>
{#if subject.content}
<article class='pl-1 row'>
{#each Object.entries(subject.content.values) as [key, value]}
{#if value != ""}
<div class='col-12 col-lg-6 justify-content-around'>
<dt>{key}</dt>
<dd>{value}</dd>
</div>
{/if}
{/each}
</article>
{/if}

{#if subject.categories}
<div class='row flex-row list-group list-group-flush'>
<div class='col-6'>
{#each subject.categories as {name, id, is_meta}, i}
{#if is_meta}
<li class='list-group-item border-0 pl-0'>
<a class='pl-4' href='/ix/{id}'>{ Object.values(name)[0]}</a>
</li>
{/if}
{/each}
</div>
<div class='col-6'>
{#each subject.categories as {name, id, is_meta}, i}
{#if !is_meta}
<li class='list-group-item border-0 pl-0'>
<a class='pl-4' href='/ix/{id}'>{ Object.values(name)[0]}</a>
</li>
{/if}
{/each}
</div>
</div>
{/if}
{#if subject.links}
<ol class='links list-group list-group-flush'>
{#each subject.links as link}
<li class='list-group-item'>
<a href='{link.uri}' target='blank'>{link.title}</a>
</li>
{/each}
</ol>
{/if}
</div>
</div>
</article>

